export const STORAGE_KEYS = {
  AUTH: "closeexp_auth",
}

export const CART_KEY = "customer_cart_v1"
export const ORDER_CONTEXT_KEY = "customer_delivery_context_v3"
export const DELIVERY_CONTEXT_KEY = ORDER_CONTEXT_KEY
export const LAST_ORDER_KEY = "customer_last_order_v1"
export const LAST_ORDER_ID_KEY = "customer_last_order_id_v1"
